<div class="sport-page-container">
  <nav class="sport-tabs">
    @for (tab of filteredTabs; track tab.path) {
      <a
        [routerLink]="tab.path"
        routerLinkActive="active"
        class="sport-tab-link">
        {{ tab.label | translate }}
      </a>
    }
  </nav>
  <div class="sport-tab-content">
    <router-outlet></router-outlet>
  </div>
</div>
